import { emptyDecorator } from '@/catalog/constants/emptyDecorator';
import { FieldType } from '@/catalog/constants/fieldTypes';
import { ALL_CONTEXTS } from '@/common/constants/context';
import Diamond from '@/product/entity/Diamond';
export const FIELD_PAVILION_COMPOSED = {
    key: 'pavilionComposed',
    label: 'Pav. Depth',
    fullLabel: 'Pavilion Depth',
    type: FieldType.Scalar,
    spGroupId: null,
    getter(p) {
        if (p instanceof Diamond && p.reportData) {
            if (p.reportData?.pavDepthPc !== null && p.reportData?.pavDepth !== null) {
                return `${p.reportData.pavDepthPc}% (${p.reportData.pavDepth} mm)`;
            }
        }
        return null;
    },
    getterPlain(p) {
        if (p instanceof Diamond && p.reportData) {
            return p.reportData?.pavDepthPc !== null ? p.reportData.pavDepthPc : null;
        }
        return null;
    },
    decorator: emptyDecorator,
    iteratee: null,
    contexts: ALL_CONTEXTS,
};
